"use client";

import React from "react";
import RevealElement from "../revealElement";
import BottomCurves from "../curves/bottomCurves";
import AnimatedButton from "../ui/AnimatedButton";
import BannerFloatingArrow from "../uiDecor/bannerFloatingArrow";
import StatCounter from "./StatCounter";
import { useLenisContext } from "../provider/lenisProvider";

type CreatorHeroStat = {
  value: string;
  label: string;
};

type CreatorHeroData = {
  eyebrow: string;
  heading: string;
  lede: string;
  ctaLabel: string;
  ctaLink: string;
  stats: CreatorHeroStat[];
  waveBgColor?: { waveBgColor: string };
};

type CreatorHeroProps = {
  data?: Partial<CreatorHeroData>;
};

const DEFAULT_DATA: CreatorHeroData = {
  eyebrow: "Kingdom Digital's Creator Network",
  heading: "Be Part of Our Creator Community",
  lede: "Love creating? Join our internal creator network for paid opportunities to work with brands and campaigns.",
  ctaLabel: "Apply Now",
  ctaLink: "#apply",
  stats: [
    { value: "500+", label: "Active Creators" },
    { value: "120+", label: "Brand Campaigns" },
    { value: "2", label: "Markets — MY & SG" },
  ],
  waveBgColor: { waveBgColor: "dark grey" },
};

export default function CreatorHero({ data }: CreatorHeroProps) {
  const content: CreatorHeroData = { ...DEFAULT_DATA, ...data };
  const { lenis } = useLenisContext();

  const isInPageLink = content.ctaLink.startsWith("#");

  function handleCtaClick() {
    lenis?.scrollTo(content.ctaLink, { duration: 2.5 });
  }

  return (
    <section className="relative bg-midGradientPurple pt-32 md:pt-24 pb-40 md:pb-44 xl:pb-64">
      <RevealElement>
        <p className="text-center text-turquoise font-mono uppercase tracking-[0.2em] body-small-fontsize mb-4">
          {content.eyebrow}
        </p>
        <h1 className="text-white text-center">{content.heading}</h1>
        <p className="text-white text-center md:px-20 mb-6">{content.lede}</p>
      </RevealElement>

      <RevealElement className="flex justify-center mt-16">
        <AnimatedButton
          text={content.ctaLabel}
          link={content.ctaLink}
          showArrow
          onClick={isInPageLink ? handleCtaClick : undefined}
        />
      </RevealElement>

      {/* {content.stats.length > 0 && (
        <RevealElement className="mt-16">
          <div className="flex flex-row justify-center items-start md:items-center gap-3 sm:gap-8 md:gap-16 max-w-5xl mx-auto">
            {content.stats.map((stat, i) => (
              <div key={i} className="text-center flex-1 md:flex-none">
                <p className="text-turquoise font-bold text-[24px] sm:text-[clamp(28px,3vw,2.5vw)] leading-none">
                  <StatCounter value={stat.value} />
                </p>
                <p className="mt-2 text-[12px] sm:text-body-small-fontsize text-white/80">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </RevealElement>
      )} */}

      <BannerFloatingArrow
        direction="right"
        name="we-are-kd"
        className="right-10 lg:right-24 !-bottom-2 md:!-bottom-12 lg:!-bottom-16 !z-30"
      />

      <BottomCurves
        color={content.waveBgColor?.waveBgColor || "dark grey"}
        direction="right"
      />
    </section>
  );
}